import {Injectable} from '@angular/core';
import {CrudService} from '@ngx-ivengi/crud';
import {Picture} from './picture.model';

@Injectable()
export class PictureService extends CrudService<Picture> {
  public entityType = Picture;
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/picture/picture.service.ts